import React, { useContext } from "react";
import { Rnd } from "react-rnd";
import { Scrollbars } from "rc-scrollbars";
import parse from "html-react-parser";
import FroalaEditor from "../../Uitls/CommonFroalaEditor";
import { toNumericStyleValue } from "../../Uitls/Util";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";
import ValueContext from "../../ContextAPi/appContext";
import { getRhsFontOptionCssStack } from "../../Uitls/CommonFroalaConfig";

export const EditorCanvasTextItem = ({ items, index }) => {
  const {
    playPauseRef,
    isEditorOn: currentEditorState,
    isAspectRatioLocked,
    canvasDimension,
    handleComponentsDrag,
    handleComponentsDragStop,
    updateFontOnResize,
    callOnResizeStop,
    isDragged,
    layerIndex,
    froalaEditorHandleOnclciksAndDrag,
    setFroalaIndex,
    setContainerID,
    setCurrentIdZindex,
    sendSelectedComponent,
    handleCtrlClick,
    setEditComponent,
    editComponentRef,
    multiSelectedComps,
    selectedComponent,
    playPause,
    scrollBarExpand,
    createFroalaInstance,
    handleTextChangeInLayerComp,
  } = useEditorMainPageContext();
  const savedCustomFontList =
    useContext(ValueContext)?.savedCustomFontList ?? [];
  let isEditorOn = currentEditorState;

  if (items?.componentType !== "Text") return null;

  return (
    <Rnd
      resizeHandleClasses={{
        topRight: "topAnchorRight",
        topLeft: "topAnchorLeft",
        bottomLeft: "bottomAnchorLeft",
        bottomRight: "bottomAnchorRight",
        top: "horizontalAnchorCenter",
        bottom: "horizontalAnchorCenter",
        left: "verticallAnchorCenter",
        right: "verticallAnchorCenter",
      }}
      disableDragging={(() => {
        return (
          items?.componentStyles?.hideBoolean ||
          items?.componentStyles?.lockBoolean ||
          !playPauseRef.current.animationCompleted ||
          isEditorOn === "true" ||
          isEditorOn === "dragged"
        );
      })()}
      enableResizing={
        !items?.componentStyles?.hideBoolean &&
        !items?.componentStyles?.lockBoolean &&
        playPauseRef.current.animationCompleted &&
        isEditorOn !== "true" &&
        isEditorOn !== "dragged"
      }
      size={{
        width: items.componentStyles.width,
        height: items.componentStyles.height,
      }}
      scale={canvasDimension.scale}
      enableUserSelectHack={false}
      position={{
        x:
          toNumericStyleValue(items.componentStyles.left) +
          (parseInt(items.componentStyles.translateX) || 0),
        y:
          toNumericStyleValue(items.componentStyles.top) +
          (parseInt(items.componentStyles.translateY) || 0),
      }}
      lockAspectRatio={isAspectRatioLocked}
      onDrag={(e, d) => {
        handleComponentsDrag(d, items);
      }}
      onDragStop={(e, d) => {
        handleComponentsDragStop(e, d, items, index);
      }}
      onResize={(e, direction, ref, delta, position) => {
        updateFontOnResize({
          id: items.id,
          width: ref.offsetWidth,
          height: ref.offsetHeight,
          x: position.x - (parseInt(items.componentStyles.translateX) || 0),
          y: position.y - (parseInt(items.componentStyles.translateY) || 0),
        });
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        callOnResizeStop({
          id: items.id,
          width: ref.offsetWidth,
          height: ref.offsetHeight,
          x: position.x - (parseInt(items.componentStyles.translateX) || 0),
          y: position.y - (parseInt(items.componentStyles.translateY) || 0),
        });
      }}
      id={items.id}
      key={index}
      onClick={(e) => {
        if (e.detail > 0) {
          if (e.detail === 3) return;
          if (isDragged.mouseMove && e.detail === 1) {
            isEditorOn = "dragged";
          } else if (isEditorOn === "dragged") {
            isEditorOn = "true";
          }
          if (index !== layerIndex) isEditorOn = "notClickedYet";
          froalaEditorHandleOnclciksAndDrag(e, index);
        }
        setFroalaIndex(index);
        setContainerID(items.id);
        setCurrentIdZindex(e.currentTarget.id);
        sendSelectedComponent(e, index);
        sendSelectedComponent(e, index);
        handleCtrlClick(e, items);
        setEditComponent(undefined);
        editComponentRef.current = undefined;
      }}
      className={
        `${
          multiSelectedComps.length < 2 && selectedComponent.id === items.id
            ? "selectedComp div-dragresize-parent cs-container textCompNew textComponent"
            : "div-dragresize-parent cs-container textCompNew textComponent"
        }` +
        " " +
        `${
          multiSelectedComps.length > 1 && items.multiSelected === true
            ? "multipleSelection"
            : ""
        }` +
        " " +
        `${
          items?.textComponentType?.addContent === "AddHeading"
            ? "headingTextComponent"
            : ""
        }`
      }
      style={{
        pointerEvents:
          (!playPause.animationCompleted ||
            items.componentStyles.hideBoolean) &&
          "none",
        fontFamily: getRhsFontOptionCssStack(
          items.componentStyles.fontFamily,
          savedCustomFontList,
        ),
        fontSize: items.componentStyles.fontSize + "px",
        fontWeight: items.componentStyles.boldClick
          ? items.componentStyles?.fontWeightBold
          : items.componentStyles?.fontWeight,
        textAlign: items.componentStyles.textAlign,
        color: items.componentStyles.color,
        zIndex: items.componentStyles.zIndex,
        letterSpacing: items.componentStyles.letterSpacing,
        lineHeight: items.componentStyles.lineHeight,
        transform: `rotate(${items.componentStyles.rotation}) rotateX(${items.componentStyles.rotationX}) rotateY(${items.componentStyles.rotationY}) scale(${items.componentStyles.scale})`,
        ease: items.componentStyles.ease,
        aspectLock: isAspectRatioLocked,
        toggleScroll: items.componentStyles.toggleScroll,
        backgroundColor: items.componentStyles.textBgColor,
        opacity: items.componentStyles.opacity,
        fontStyle: items.componentStyles.fontStyle,
        textTransform: items.componentStyles?.textTransform,
        webkitTransformOrigin: `${items.componentStyles.transformOriginX}% ${items.componentStyles.transformOriginY}% ${items.componentStyles.transformOriginZ}px`,
        textDecoration: items.componentStyles?.underlineClick
          ? items.componentStyles?.strikeThroughClicked
            ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
            : items.componentStyles?.textDecUnderline
          : items.componentStyles?.textDecoration,
      }}
    >
      {" "}
      {items?.componentStyles.expandAndClose === true ? (
        <div
          id={"expandClose" + items.id}
          ref={(e) => (scrollBarExpand.current[index] = e)}
          style={{
            fontFamily: getRhsFontOptionCssStack(
              items.componentStyles?.expandClose?.fontFamily,
              savedCustomFontList,
            ),
            fontSize: items.componentStyles?.expandClose.fontSize,
            fontWeight: items.componentStyles.expandClose.boldClick
              ? items.componentStyles?.expandClose.fontWeightBold
              : items.componentStyles?.expandClose.fontWeight,
            textAlign: "right",
            color: items.componentStyles?.expandClose?.fontColorISI,
            backgroundColor: items.componentStyles?.expandClose.textBgColorISI,
            letterSpacing: items.componentStyles?.expandClose.letterSpacing,
            lineHeight: items.componentStyles?.expandClose.lineHeight,
            fontStyle: items.componentStyles?.expandClose.fontStyle,
            textTransform: items.componentStyles?.expandClose.textTransform,
            textDecoration: items.componentStyles?.expandClose.underlineClick
              ? items.componentStyles?.expandClose.strikeThroughClicked
                ? `${items.componentStyles?.expandClose.textDecUnderline} ${items.componentStyles?.expandClose?.textDecoration} `
                : items.componentStyles?.expandClose?.textDecUnderline
              : items.componentStyles?.expandClose?.textDecoration,
            overflow: "hidden",
          }}
        >
          + {items?.componentStyles.expandText}
        </div>
      ) : (
        ""
      )}
      {items?.componentStyles.toggleScroll === true ? (
        <>
          <div
            id="upArrowButtons"
            style={{
              width: items.componentStyles.arrowWidth,
              height: items.componentStyles.arrowHeight,
              backgroundImage: `url("${items.componentStyles.scrollUpArrowbg}")`,
              backgroundSize: items.componentStyles.backgroundSize,
              backgroundPosition: `50% 50%`,
              left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
            }}
          ></div>

          <Scrollbars
            style={{
              width: "100%",
              height: `calc(${items.componentStyles.height - items.componentStyles.expandClose?.expandHeight}px)`,
              top: `-${items.componentStyles.arrowHeight}px`,
              overflow: "hidden",
              textDecoration: items.componentStyles?.underlineClick
                ? items.componentStyles?.strikeThroughClicked
                  ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                  : items.componentStyles?.textDecUnderline
                : items.componentStyles?.textDecoration,
            }}
            universal={true}
            className="scrollBarText"
            renderTrackVertical={({ style, ...props }) => (
              <div
                {...props}
                className={"rc-scrollbars-track-v"}
                style={{
                  ...style,
                  backgroundColor:
                    items.componentStyles.thumbColor || "transparent",
                  bottom: "2px",
                  top: `${items.componentStyles.arrowHeight + 2}px`,
                  borderRadius: "3px",
                  height: `calc( ${
                    items.componentStyles.height -
                    items.componentStyles.expandClose?.expandHeight -
                    items.componentStyles.arrowHeight * 2 -
                    4
                  }px)`,
                }}
              />
            )}
            disableDefaultStyles={true}
            thumbSize={items.componentStyles.thumbHeight}
            thumbMinSize={30}
          >
            {items.componentStyles.lockBoolean !== true ? (
              <FroalaEditor
                forwardedRef={(e) => (createFroalaInstance.current[index] = e)}
                handleModelChange={(e) => {
                  handleTextChangeInLayerComp(e, index);
                }}
                className=""
                defaultText={items.froalaText}
                tag="textarea"
                showToolBar={false}
                scrollBarStyleWidth={
                  items.componentStyles.thumbRight * 2 +
                  items.componentStyles.trackWidth +
                  2
                }
              ></FroalaEditor>
            ) : (
              <div>{parse(items.froalaText || "")}</div>
            )}
          </Scrollbars>

          <div
            id="DownArrowButtons"
            style={{
              width: items.componentStyles.arrowWidth,
              height: items.componentStyles.arrowHeight,
              backgroundImage: `url("${items.componentStyles.scrollDownArrowbg}")`,
              backgroundSize: items.componentStyles.backgroundSize,
              backgroundPosition: `50% 50%`,
              left: `calc(100% - ${items.componentStyles.arrowWidth}px)`,
            }}
          ></div>
        </>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
            textDecoration: items.componentStyles?.underlineClick
              ? items.componentStyles?.strikeThroughClicked
                ? `${items.componentStyles?.textDecUnderline} ${items.componentStyles?.textDecoration} `
                : items.componentStyles?.textDecUnderline
              : items.componentStyles?.textDecoration,
          }}
        >
          {items.componentStyles.lockBoolean !== true ? (
            <FroalaEditor
              forwardedRef={(e) => (createFroalaInstance.current[index] = e)}
              handleModelChange={(e) => {
                handleTextChangeInLayerComp(e, index);
              }}
              className=""
              defaultText={items.froalaText}
              tag="textarea"
              showToolBar={false}
            ></FroalaEditor>
          ) : (
            <div>{parse(items.froalaText || "")}</div>
          )}
        </div>
      )}
    </Rnd>
  );
};
